import uniqueId from 'lodash.uniqueid';
import { useState } from 'react';

import './checkbox.scss';

const Checkbox = ({ label, checked, className = '', small, disabled, onChange, role = '' }) => {
  const onChangeHandler = (ev) => {
    onChange?.(ev.target.checked);
  };

  const [id] = useState(() => uniqueId('check-'), []);

  return (
    <div className={`custom-checkbox ${small ? 'small' : ''} ${className}`} role={role}>
      <div className="checkbox-wrapper">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChangeHandler}
        />
        <span className="checkmark" />
      </div>
      {label && (
        <label className="labeltext" htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
